<template>
  <div class="cv-page p-6 md:p-12 bg-gray-900 min-h-screen">
    <div class="text-center mb-12">
      <h1 class="text-4xl md:text-5xl font-bold text-white mb-2">My CV</h1>
      <p class="text-gray-400 text-lg">Downloadable and scrollable version of my resume.</p>
    </div>

    <div class="pdf-container rounded-lg shadow-xl overflow-auto">
      <iframe
          :src="pdfUrl"
          width="100%"
          height="100%"
          style="border: none;"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CVPage',
  data() {
    return {
      pdfUrl: `/pdfs/CV.pdf?v=${Date.now()}` // forces fresh PDF every load
    };
  }
};
</script>

<style scoped>
.pdf-container {
  height: 800px;
  background-color: #2d3748;
}
</style>